module.exports = __webpack_public_path__ + "static/behave-3fada9ed3bf50c6409c239be8f4f248d.jpg";